import { createContext, useContext } from 'react';

export interface PopoverContextState {
  close: () => void;
}

export const PopoverContext = createContext<PopoverContextState | undefined>(
  undefined,
);

export const usePopoverContext = () => {
  const context = useContext(PopoverContext);

  if (!context)
    throw new Error('usePopoverContext can only be used inside a Popover');

  return context as PopoverContextState;
};
